<lx-dropdown-side-panel-field
  (ngModelChange)="onSelectValue($event)"
  [title]="title"
  (blurred)="markAsTouched()"
  [(ngModel)]="selectedValue"
  data-qa="motherTongueSelector"
  [options]="motherTongues"
  optionLabel="name"
  optionValue="code"
  [filter]="true"
  filterBy="name"
  placeholder="Select"
>
</lx-dropdown-side-panel-field>
